import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AppLogo from "../components/AppLogo";
import { apiPostPublic, apiPostAuth} from "../utils/api";
import "../App.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        const response = await apiPostAuth("account/is_logged_in.php");
        if (response.status === 'success') {
          window.location.href = "/dashboard";
        } 
      } catch (error) {
        
      }
    };

    checkLogin();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Make API call to login.php
      const response = await apiPostPublic("login.php", {
        email: email,
        password: password,
      });


      if (response.result === 1) {
        // Redirect user to dashboard page
        window.location.href = "/dashboard";
      } else {
        alert(response.message || "Login failed. Please try again.");
      }
    } catch (error) {
      alert("Terjadi kesalahan saat masuk.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <AppLogo />
        <h2 className="form-title">Masuk ke Akun Kamu</h2>
        <form onSubmit={handleLogin} className="form-container">
          <input
            type="email"
            placeholder="Email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>

          <div className="forgot-password">
            <Link to="/forgot-password" className="link">Lupa Password?</Link>
          </div>

          <button type="submit" className="primary-button">Masuk</button>
        </form>

        <p className="form-footer">
          Don’t have an account? <Link to="/register" className="link">Buat Akun</Link>
        </p>
        <div className="copyright">© MySite.co.id 2025</div>
      </div>
    </div>
  );
};

export default LoginPage;
